<div class="infinite-scroll-container">
  <ng-content></ng-content>
  <div id="anchor" #anchor></div>
</div>
